import { GameListSelector } from "../components/gameListSelector.jsx";
import { ProgressHeaderWithPopup } from "../components/progressHeaderWithPopup.jsx";
import { HeadLogo } from "../components/headLogo.jsx";
import { timeGameList, spaceGameList } from "../data/gameList.js";
import { LocationImageDisplay } from "../components/locationImageDisplay.jsx";


function ModeSelectionGameView({ selectedMode, locTitle, locProgress, imageKey, onGameClickACB }) {
  const travelTitle = selectedMode === "time" ? "Time Travel!" : "Space Travel!";
  const gameList = selectedMode === "time" ? timeGameList : spaceGameList;

  return (
    <div >
      <HeadLogo />
      <ProgressHeaderWithPopup currentStep={2} title={locTitle} />
      <div className="modeSelection-gameSelect">
        <div className="modeSelection-title">{travelTitle}</div>
        <div className="global-description">Select your quest:</div>
        <GameListSelector
          gameList={gameList}
          locProgress={locProgress}
          selectedMode={selectedMode}
          handleGameClickACB={onGameClickACB}
        />
      </div>
      <LocationImageDisplay imageKey={imageKey} dynamicHeight="40vh" />
    </div>
  );
}

export { ModeSelectionGameView };
